import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title as UiTitle } from '@/shared/uikit/Title';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 72px calc(100% - 72px - 92px) 92px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px 24px 0;
  overflow: hidden;
  border-bottom: 1px solid ${COLORS.systemDark100};
`;

export const Body = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  overflow: scroll;
`;

export const Title = styled(UiTitle)`
  max-width: calc(100% - 32px);
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
`;

export const Actions = styled.div`
  padding-inline: 24px;
  border-top: 1px solid ${COLORS.systemDark100};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const LockContainer = styled.div`
  position: absolute;
  inset: 72px 0 92px 0;
  z-index: 1;
  background: rgba(255, 255, 255, 0.72);
`;
